import React, { Fragment, FunctionComponent, useEffect, useRef, useState } from 'react';
import './mpinSuccess.scss'
import { useHistory } from 'react-router-dom';
import success from '../../assets/images/mpin-success.svg';
import {
    APP_URLS,
  } from '../../constants/constants';
import { getTransactionIdFromURL } from '../../constants/utils';
import { MPIN_SUCCESS_PAGELOAD_PARAM, MPIN_SUCCESS_PAGELOAD_VPV, pushDataLayer } from '../../constants/gaConstants';

const MpinSuccess = () => {
    const history = useHistory();
    const transactionId = getTransactionIdFromURL()
    //to redirect to txn details after 5 sec
    useEffect(()=>{
        pushDataLayer(MPIN_SUCCESS_PAGELOAD_VPV(transactionId))
        pushDataLayer(MPIN_SUCCESS_PAGELOAD_PARAM(transactionId))

        setTimeout(() => {
            history.push(`${APP_URLS.TRANSACTION_DETAILS.replace(":txnId", transactionId)}`)
          }, 2000)
    },[transactionId])
    return(
        <Fragment>
            <div className='mpin-success'>
                <div className='mpin-success__icon'><img src={success}/></div>
                <div className='mpin-success__text'>Successful Login</div>
            </div>
        </Fragment>
    )
}

export default MpinSuccess;